import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, useIsForman } from '../../helpers/hooks';

interface FormanGuardProps {
  children: React.ReactNode;
}

const FormanGuard: React.FC<FormanGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const isForman = useIsForman();
  const location = useLocation();

  // Not authenticated -> login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Not forman -> redirect to main dashboard
  if (!isForman) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default FormanGuard;
